import React, { useEffect, useState } from 'react';
import { Table, Checkbox } from 'antd';

interface UserRole {
  roleCode: string;
}

interface User {
  name: string;
  email: string;
  roles: UserRole[];
  emailNotification?: boolean;
  _id: string; // <-- Make _id required
}

interface OrgNotificationTabProps {
  users: User[];
  adminNotifications: Record<string, boolean>;
  setAdminNotifications: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
}

const OrgNotificationTab: React.FC<OrgNotificationTabProps> = ({ users, adminNotifications, setAdminNotifications }) => {
  const companyAndBatchAdmins = users.filter(
    user =>
      user.roles &&
      user.roles.some(
        role =>
          role.roleCode === 'COMPANY_ADMIN' ||
          role.roleCode === 'BATCH_ADMIN'
      )
  );

  const handleNotificationChange = (email: string, checked: boolean) => {
    setAdminNotifications(prev => ({
      ...prev,
      [email]: checked,
    }));
  };

  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    {
      title: 'Email Notification',
      dataIndex: 'emailNotification',
      key: 'emailNotification',
      render: (_: any, record: any) => (
        <Checkbox
          checked={!!adminNotifications[record.email]}
          onChange={e => handleNotificationChange(record.email, e.target.checked)}
        >
          Yes
        </Checkbox>
      ),
    },
  ];

  return (
    <Table
      dataSource={companyAndBatchAdmins}
      columns={columns}
      rowKey="email"
      pagination={false}
      style={{ marginTop: 24, marginBottom: 24 }}
    />
  );
};

export default OrgNotificationTab;